import React from 'react';
import BloxButton from 'sub_components/Common/BloxButton';
import { Permissions } from 'services/permissions';

const CDN_URL = process.env.REACT_APP_CDN_URL;

const BillingDefault = `${CDN_URL}support/ticketing/icon-billing-default-lg.svg`;
const BillingSelected = `${CDN_URL}support/ticketing/icon-billing-selected-lg.svg`;
const OutageDefault = `${CDN_URL}support/ticketing/icons-outage-default-lg.svg`;
const OutageSelected = `${CDN_URL}support/ticketing/icon-outage-selected-lg.svg`;
const SupportDefault = `${CDN_URL}support/ticketing/icons-support-default-lg.svg`;
const SupportSelected = `${CDN_URL}support/ticketing/icon-support-selected-lg.svg`;
const ilaDefault = `${CDN_URL}support/ticketing/icon-ila-default-lg.svg`;
const ilaSelected = `${CDN_URL}support/ticketing/icon-ila-selected-lg.svg`;

function onMouseEnter(id, selected) {
	const icon = document.getElementById(id);
	const outageIcon = selected === 'outage' ? OutageSelected : OutageDefault;
	const billingIcon = selected === 'billing' ? BillingSelected : BillingDefault;
	const supportIcon = selected === 'support' ? SupportSelected : SupportDefault;
	const ilaIcon = selected === 'ila' ? ilaSelected : ilaDefault;

	if (id === 'Billing') {
		icon.src = selected === 'billing' ? billingIcon : BillingSelected;
	} else if (id === 'Outage') {
		icon.src = selected === 'outage' ? outageIcon : OutageSelected;
	} else if (id === 'ila') {
		icon.src = selected === 'ila' ? ilaIcon : ilaSelected;
	} else {
		icon.src = selected === 'support' ? supportIcon : SupportSelected;
	}
}
function onMouseLeave(id, typeIcon) {
	const icon = document.getElementById(id);

	icon.src = typeIcon;
}
function getPermissions(pages) {
	const billingPermission = Permissions.checkComponentAccess(
		pages,
		'Overview',
		'add-support-billing',
	);
	const outagePermission = Permissions.checkComponentAccess(
		pages,
		'Overview',
		'add-support-outage',
	);
	const supportPermission = Permissions.checkComponentAccess(
		pages,
		'Overview',
		'add-support-support',
	);

	return { billingPermission, outagePermission, supportPermission };
}

const TicketTypeSelection = ({ data, onSelect, closeModal, pages }) => {
	const selected = data.type;
	const outageIcon = selected === 'outage' ? OutageSelected : OutageDefault;
	const billingIcon = selected === 'billing' ? BillingSelected : BillingDefault;
	const supportIcon = selected === 'support' ? SupportSelected : SupportDefault;
	const { billingPermission, outagePermission, supportPermission } = getPermissions(pages);
	const allTypes = supportPermission && outagePermission && billingPermission ? true : false;

	return (
		<div className='ticket-type-selection-stage'>
			<div
				className={
					allTypes ? `ticket-type-selection-wrapper wrap` : `ticket-type-selection-wrapper`
				}
			>
				{billingPermission && (
					<div
						className={`type-selection billing`}
						onClick={() => onSelect('type', { data: 'billing' }, true)}
						onMouseEnter={() => onMouseEnter('Billing', selected)}
						onMouseLeave={() => onMouseLeave('Billing', billingIcon)}
						data-cy='type-selection-billing'
						id='type-selection-billing'
					>
						<img src={billingIcon} id='Billing' />
						<div className='title heading76'>Billing</div>
					</div>
				)}
				{outagePermission && (
					<div
						className={`type-selection  outage`}
						onClick={() => onSelect('type', { data: 'outage' }, true)}
						onMouseEnter={() => onMouseEnter('Outage', selected)}
						onMouseLeave={() => onMouseLeave('Outage', outageIcon)}
						data-cy='type-selection-outage'
						id='type-selection-outage'
					>
						<img src={outageIcon} id='Outage' />
						<div className='title heading76'>Outage</div>
					</div>
				)}
				{supportPermission && (
					<div
						className={`type-selection  support`}
						onClick={() => onSelect('type', { data: 'support' }, true)}
						onMouseEnter={() => onMouseEnter('Support', selected)}
						onMouseLeave={() => onMouseLeave('Support', supportIcon)}
						data-cy='type-selection-support'
						id='type-selection-support'
					>
						<img src={supportIcon} id='Support' />
						<div className='title heading76'>General Support</div>
					</div>
				)}
				{/* {hutPermission && (
					<div
						className={`type-selection  support`}
						onClick={() => onSelect('type', { data: 'ila' }, true)}
						onMouseEnter={() => onMouseEnter('ila', selected)}
						onMouseLeave={() => onMouseLeave('ila', ilaIcon)}
						data-cy='type-selection-ila'
						id='type-selection-ila'
					>
						<img src={ilaIcon} id='ila' />
						<div className='title heading76'>ILA Sites</div>
					</div>
				)} */}
				{!supportPermission && !outagePermission && !billingPermission && (
					<div className='body10'>You do not have permission to create a support ticket.</div>
				)}
			</div>

			<div className='cancel-button'>
				<BloxButton
					title='CANCEL'
					enabled={true}
					customClass='blox-button-swipe'
					onClick={closeModal}
					id='cancel-button-swipe'
				/>
			</div>
		</div>
	);
};

export default TicketTypeSelection;
